import { createI18n } from 'vue-i18n';
import en from './locales/en.json';
import mne from './locales/mne.json';

function hasEnInUrl(url) {
  // handles language routing for Air Montenegro website checks if en or en- in part of the url
  const parts = url.split('/').filter(Boolean); // Remove empty parts
  return parts.some((part) => /^en\b/.test(part));
}

function getDefaultLocale() {
  const window_url = window.location.href;
  return hasEnInUrl(window_url) ? 'en' : 'mne';
}

export const i18n = createI18n({
  legacy: false,
  locale: getDefaultLocale(),
  fallbackLocale: 'mne',
  messages: {
    en,
    mne,
  },
});
